var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-area",class:_vm.fullHeight ? 'full-height' : 'small-height'},[_c('v-row',{staticClass:"spinner-row"},[_c('v-col',{attrs:{"align-self":"center"}},[_c('v-progress-circular',{attrs:{"size":_vm.size,"color":"primary","indeterminate":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }